
import { combineReducers } from "redux";
import { ModalPopupReducer } from "../Reducers/ModalPopUpReducer";
import CommonMastersReducer from "../Reducers/CommonMastersReducer";
import { loaderReducer } from "../Reducers/LoginReducer";
import CourseReducer from "../CommonUtils/Reducers/CourseSlice";


const rootReducer = combineReducers({
  loaderReducer,
  modalState: ModalPopupReducer,
  commonMastersReducer: CommonMastersReducer,
  course: CourseReducer,
});
export default rootReducer;
